<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">会话列表</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="未质检" name="first">
                <Nocheck :options="options"></Nocheck>
              </el-tab-pane>
              <el-tab-pane label="已质检" name="second">
                <Checked :options="options"></Checked>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checked from './sessionList/checked';
import Nocheck from './sessionList/nocheck';
import { getInspectionSelect } from '@/api/vipQualityTest';

export default {
  components: {
    Checked,
    Nocheck,
  },
  data() {
    return {
      activeName: 'first',
      options: {},
    };
  },
  mounted() {
    this.getInspectionSelect();
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
    },
    // 获取下拉列表选项
    async getInspectionSelect() {
      const { data } = await getInspectionSelect();
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      // 处理数据
      data.data.check = data.data.check.map((item) => {
        return { label: item.name, value: item.id };
      });
      data.data.channel = data.data.channel.map((item) => {
        return { label: item.name, value: item.id };
      });
      data.data.nickname = data.data.nickname.map((item) => {
        return { label: item, value: item };
      });
      data.data.admin = data.data.admin.map((item) => {
        return { label: item.name, value: item.id };
      });
      data.data.result = data.data.result.map((item) => {
        return { label: item.name, value: item.id };
      });
      data.data.time = data.data.time.map((item) => {
        return { label: item.name, value: item.id };
      });
      data.data.tag = data.data.tag.map((item) => {
        return { label: item.name, value: item.id };
      });
      data.data.checkout = data.data.checkout.map((item) => {
        return { label: item.name, value: item.id };
      });
      this.options = data.data;
    },
  },
};
</script>

<style>
</style>